import { heapAddUserProperties } from './heap/heapAddUserProperties';
import { heapIdentify } from './heap/heapIdentify';
import { heapTrack } from './heap/heapTrack';
import { heapUserEvent } from './heap/heapUserEvent';

export const identify = guid => heapIdentify(guid);

export const track = (label, object) => heapTrack(label, object);

export const addUserProperties = props => heapAddUserProperties(props);

export const userEvent = (guid, label, object) => heapUserEvent(guid, label, object);

export const optionsShown = standardOptions => {
  const hasStandardOptions = standardOptions.some(option => option.loan_type === 'standard');
  const hasCosignerOptions = standardOptions.some(
    option => option.loan_type === 'cosigner_inschool',
  );

  if (hasStandardOptions && !hasCosignerOptions) {
    return 'Standard options only';
  }
  if (!hasStandardOptions && hasCosignerOptions) {
    return 'Cosigner options only';
  }
  if (hasStandardOptions && hasCosignerOptions) {
    return 'Standard and Cosigner options';
  }

  return 'No options available';
};
